module.exports = __webpack_public_path__ + "img/cosmomo-works.48556070.png";